import { CheckCheck, Clock } from 'lucide-react'
import { format } from 'date-fns'
import { completedDurationLabel, formatTimer } from './cardDetailUtils'

export default function CardTimePanel({
    t,
    card,
    timeLogs,
    groupedTimeLogs,
    activeTimer,
    effectiveIsCompleted,
    effectiveTimerStartedAt,
    userId,
    companyMembers,
    loadingAverage,
    averageMinutes,
}) {
    return (
        <div className="cd-time-card">
            <div className="cd-time-header">
                <Clock size={16} color="var(--accent-blue)" />
                <span className="cd-time-title">{t('card.timer.heading')}</span>
            </div>

            {effectiveIsCompleted ? (
                <div className="cd-time-timer">
                    <div className="cd-time-display" style={{ color: 'var(--accent-green, #16a34a)' }}>
                        {completedDurationLabel(timeLogs, card)}
                    </div>
                    <span className="cd-time-status" style={{ color: 'var(--accent-green, #16a34a)' }}>
                        <CheckCheck size={14} />
                        {t('card.timer.statusCompleted', { defaultValue: 'Finalizat' })}
                    </span>
                </div>
            ) : (
                <div className="cd-time-timer">
                    <div className={`cd-time-display ${effectiveTimerStartedAt ? 'running' : ''}`}>
                        {formatTimer(activeTimer)}
                    </div>
                    <span className={`cd-time-status ${effectiveTimerStartedAt ? 'running' : ''}`}>
                        <Clock size={14} />
                        {effectiveTimerStartedAt
                            ? t('card.timer.statusRunning', { defaultValue: 'În proces' })
                            : t('card.timer.statusIdle', { defaultValue: 'Inactiv' })}
                    </span>
                </div>
            )}

            <div className="cd-time-history">
                <label className="cd-field-label-medium">{t('card.timer.sessions')}</label>
                <div className="cd-time-log-scroll">
                    {groupedTimeLogs.length > 0 ? (
                        groupedTimeLogs.map((log) => {
                            const who = log.user_id === userId
                                ? t('card.timer.you')
                                : (companyMembers?.find((m) => m.id === log.user_id)?.full_name || t('card.timer.member'))
                            return (
                                <div key={log.id} className="cd-time-log-entry">
                                    <span className="cd-time-log-duration">
                                        {t('card.timer.duration', {
                                            name: who,
                                            hours: Math.floor(log.duration_minutes / 60),
                                            minutes: log.duration_minutes % 60,
                                        })}
                                    </span>
                                    <span className="cd-time-log-date">
                                        {format(new Date(log.created_at), 'dd MMM, HH:mm')}
                                    </span>
                                </div>
                            )
                        })
                    ) : (
                        <div className="cd-time-log-empty">
                            {t('card.timer.empty')}
                        </div>
                    )}
                </div>
            </div>

            {!loadingAverage && averageMinutes > 0 && (
                <div className="cd-time-avg">
                    {t('card.timer.average', {
                        hours: Math.floor(averageMinutes / 60),
                        minutes: averageMinutes % 60,
                    })}
                </div>
            )}
        </div>
    )
}
